import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=eccf05d2"
import script from "./settings.js?vue&type=script&lang=js&external"
export * from "./settings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports